import React, { useState } from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
// import { BiddingsStateTypes } from 'store/modules/bidding_store/types';
import Loader from 'components/atoms/loader';
import { OnlineSearchTypes } from 'store/modules/online_search_store/types';
import { useDispatch } from 'react-redux';
import { States } from 'services/states';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface OpportunityMapDashboardProps {
  biddings_future_by_state: Array<any>;
  loading: boolean;
}

const OpportunityMapDashboard = (props: OpportunityMapDashboardProps) => {
  const { biddings_future_by_state, loading } = props;
  const dispatch = useDispatch();

  const geoUrl =
    'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson';

  const [hoveredState, setHoveredState] = useState({ nome: '', valor: 0, coordinates: [0, 0] });

  const coordenadas: any = {
    Acre: [-70.55, -9.97499],
    Alagoas: [-36.5513, -9.5713],
    Amazonas: [-60.0217, -3.41684],
    Amapá: [-51.0694, 0.0371],
    Bahia: [-38.5161, -12.9704],
    Ceará: [-38.5267, -3.71722],
    'Distrito Federal': [-47.9292, -15.7801],
    'Espírito Santo': [-40.3444, -20.3155],
    Goiás: [-49.2655, -16.6864],
    Maranhão: [-44.2968, -2.55],
    'Minas Gerais': [-44.555, -19.9173],
    'Mato Grosso do Sul': [-54.6465, -20.4697],
    'Mato Grosso': [-56.0979, -15.5989],
    Pará: [-48.5044, -1.45502],
    Paraíba: [-35.2248, -7.11509],
    Pernambuco: [-34.8813, -8.04756],
    Piauí: [-42.7984, -5.08921],
    Paraná: [-51.9253, -24.3954],
    'Rio de Janeiro': [-43.1729, -22.9068],
    'Rio Grande do Norte': [-35.2096, -5.79448],
    Rondônia: [-63.9039, -8.76116],
    Roraima: [-60.6738, 2.82384],
    'Rio Grande do Sul': [-51.2302, -30.0346],
    'Santa Catarina': [-49.0661, -27.5954],
    Sergipe: [-37.074, -10.9472],
    'São Paulo': [-46.6333, -23.5505],
    Tocantins: [-48.3541, -10.184],
  };

  const estados = biddings_future_by_state?.map((estado) => ({
    nome: estado?.estado_name,
    valor: estado?.total,
    coordinates: coordenadas[estado?.estado_name] || [0, 0],
  }));

  const handleMouseEnter = (nome: string) => {
    const estado = estados.find((estado) => estado.nome === nome);
    if (estado) {
      setHoveredState({
        nome: estado?.nome,
        valor: estado?.valor,
        coordinates: estado?.coordinates,
      });
    }
  };

  const handleClick = (stateName: string) => {
    const selectedState = States.find((estado) => estado.label === stateName);
    if (selectedState) {
      dispatch({
        type: OnlineSearchTypes.STATE_FROM_PANEL,
        field: 'states',
        states_from_panel: [
          {
            value: selectedState?.value,
            label: selectedState?.label,
            uf: selectedState.uf,
          },
        ],
      });
      window.location.href = `/banco_de_dados`;
    }
  };

  return (
    <Container className="card-container position-relative h-100">
      {loading ? (
        <Loader />
      ) : (
        <div className="d-flex">
          <div className="w-50">
            <h5>Licitações por estado</h5>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {estados?.slice(0, 6)?.map((estado) => (
                <li key={estado?.nome} style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{estado?.nome}</span>
                  <span>{estado?.valor}</span>
                </li>
              ))}
            </ul>
            <a
              href="/banco_de_dados"
              onClick={() =>
                createTrack('Dashboard - Clicou em ver mais nas Licitações por estado')
              }
            >
              Ver mais
            </a>
          </div>
          <div className="w-100">
            <ComposableMap
              projection="geoMercator"
              projectionConfig={{
                scale: 800,
                center: [-54, -14],
                rotate: [0, 0, 0],
              }}
              style={{
                width: '100%',
                maxWidth: '600px',
                height: 'auto',
                padding: 0,
                position: 'relative',
              }}
            >
              <Geographies geography={geoUrl}>
                {({ geographies }: any) =>
                  geographies.map((geo: any) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      onClick={() => handleClick(geo.properties.name)}
                      onMouseEnter={() => handleMouseEnter(geo.properties.name)}
                      style={{
                        default: {
                          fill: '#6BAC9D',
                          outline: 'none',
                          stroke: '#FFFFFF',
                          strokeWidth: 1.0,
                        },
                        hover: {
                          fill: '#368E7A',
                          outline: 'none',
                        },
                      }}
                    />
                  ))
                }
              </Geographies>

              {hoveredState.nome && (
                <Marker coordinates={hoveredState.coordinates}>
                  <text
                    textAnchor="middle"
                    style={{
                      fontFamily: 'system-ui',
                      fill: '#000',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    }}
                  >
                    {`${hoveredState.nome} - ${hoveredState.valor}`}
                  </text>
                </Marker>
              )}
            </ComposableMap>
          </div>
        </div>
      )}
    </Container>
  );
};
export default OpportunityMapDashboard;
